import View from "./View";

class menuView extends View {
  _menuMobileIcon = document.querySelector(".header__nav-mobile-icon");
  _menuMobileLink = document.querySelector(".mobile__icon__link");
  _navMobile = document.querySelector(".header__nav");

  addHandlerOpenMenu() {
    this._menuMobileLink?.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggleMenu();
    });
  }

  _toggleMenu() {
    //Toggle animation on nav btn
    this._menuMobileLink.classList.toggle("mobile__icon__link--open");

    //Show nav
    this._navMobile.classList.toggle("header__nav--open");
  }
}

export default new menuView();
